import { useEffect } from 'react'; // Add this import

import { Input } from '@/components/Input';
import { selectBalloon, setBalloon } from '@/context/borrower';
import { selectPartner } from '@/context/display';
import { store } from '@/context/store';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { MAXIMUM_BALLOON_PERCENT } from '@/utils/constants';
import { getNumber } from '@/utils/valueFormat';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'Balloon';

export function Balloon({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const balloonFromRedux = useAppSelector(selectBalloon);
    const partnerDefaultBalloon =
        store.getState().displayReducer.partner?.loanBalloon;
    const currentState = balloonFromRedux ?? partnerDefaultBalloon;
    const dispatch = useAppDispatch();
    const partner = useAppSelector(selectPartner);
    const maximum = partner?.maxBalloonPercent || MAXIMUM_BALLOON_PERCENT;

    // ***** Initialize with partner default *****
    useEffect(() => {
        // Only set the default if there's no value in Redux and there's a partner default
        if (
            balloonFromRedux === undefined &&
            partnerDefaultBalloon !== undefined
        ) {
            dispatch(setBalloon(partnerDefaultBalloon));
        }
    }, [balloonFromRedux, partnerDefaultBalloon, dispatch]);

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        // MAXIMUM
        const intValue = getNumber(value, maximum);
        if (intValue === currentState) return;
        dispatch(setBalloon(intValue));
    }

    // ***** Render *****
    return (
        <div data-testid={testId} className='w-full'>
            <Input
                title='Balloon (percentage)'
                placeholder='Optional'
                showErrors={showErrors}
                onChange={handleChange}
                id={`${baseId}-input-balloon`}
                value={currentState?.toString() ?? ''}
                showNumpad={true}
                tooltipContent='The % of the loan amount you want to pay as a lump sum at the end.'
            />
        </div>
    );
}
